/* TummyHush why-we-give test. Band PDP, all devices.
   Arm G shows the block; arm C keeps it hidden. QA skips attribution. */
(function () {
  'use strict';
  var block = document.querySelector('[data-th-give-ab]');
  if (!block) return;

  var share = Math.max(0, Math.min(100, Number(block.getAttribute('data-share')) || 0));
  var force = block.getAttribute('data-force') || 'none';
  var param = (location.search.match(/[?&]th_give_ab=([GC])(?:&|$)/) || [])[1];
  var qa = false;
  var bucket = null;
  if (param) { bucket = param; qa = true; }
  else if (force === 'G' || force === 'C') { bucket = force; qa = true; }
  else if (share > 0) {
    var stored = null;
    try { stored = localStorage.getItem('th_give_ab'); } catch (error) { /* Storage may be blocked. */ }
    if (stored === 'G' || stored === 'C') bucket = stored;
    else {
      bucket = Math.random() * 100 < share ? 'G' : 'C';
      try { localStorage.setItem('th_give_ab', bucket); } catch (error) { /* Keep the in-memory bucket. */ }
    }
  }
  if (!bucket) return;

  if (bucket === 'G') block.removeAttribute('hidden');
  if (qa) return;

  function ga(name) {
    try { if (typeof gtag === 'function') gtag('event', name); } catch (error) { /* Optional analytics. */ }
  }

  function stamp() {
    try {
      if (typeof fetch !== 'function') return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        if (!cart || !(cart.item_count > 0) || attrs.th_give_ab === bucket) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { th_give_ab: bucket } })
        });
      }).catch(function () { /* Attribution only. */ });
    } catch (error) { /* Fetch may be unavailable or fail synchronously. */ }
  }

  try { if (typeof gtag === 'function') gtag('set', 'user_properties', { give_ab_bucket: bucket }); } catch (error) { /* Optional analytics. */ }
  var exposed = false;
  try { exposed = sessionStorage.getItem('th_give_ab_exposed') === '1'; } catch (error) { /* Optional analytics. */ }
  if (!exposed) {
    try { sessionStorage.setItem('th_give_ab_exposed', '1'); } catch (error) { /* This execution still emits only once. */ }
    ga('th_give_exposed_' + bucket);
  }

  var sentinel = document.querySelector('[data-th-give-sentinel]');
  if (sentinel && typeof IntersectionObserver === 'function') {
    var seen = false;
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!seen && entries[i].isIntersecting) {
          seen = true;
          ga('th_give_seen_' + bucket);
          observer.disconnect();
        }
      }
    }, { threshold: 0 });
    observer.observe(sentinel);
  }

  stamp();
  /* PUB_SUB_EVENTS is a top-level const, not a window property. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { stamp(); });
  }
})();
